import {
    defaultBaseQuery,
    transformErrorResponse,
    transformRequest,
    transformSuccessResponse,
    buildFormData
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const MyApplicationApi = createApi({
    reducerPath: "MyApplicationApi",
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        getMyApplication: builder.query({
            query: () => ({
                url: `scholarship/applied`,
                method: 'GET',
                transformRequest: transformRequest
            }),
            transformErrorResponse: transformErrorResponse,
            transformResponse: transformSuccessResponse
        }),
        getMyApplicationById: builder.query({
            query: ({ id }) => ({
                url: `scholarship/applied/${id}`,
                method: 'GET',
                transformRequest: transformRequest
            }),
            transformErrorResponse: transformErrorResponse,
            transformResponse: transformSuccessResponse
        })
    }),
});

export const { useLazyGetMyApplicationQuery, useLazyGetMyApplicationByIdQuery } = MyApplicationApi;

export default MyApplicationApi;